import React from 'react'

const NotAssignBrand = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center min-vh-100 p-3">
                <div className="text-center p-5 rounded shadow" style={{
                    maxWidth: '500px',
                    width: '100%',
                    backgroundColor: '#fff8e6',
                    border: '2px solid #ffe3b5'
                }}>

                    {/* Icon */}
                    <div className="mb-4">
                        <i className="fas fa-exclamation-circle" style={{
                            fontSize: '3rem',
                            color: '#ff9800'
                        }}></i>
                    </div>

                    {/* Title */}
                    <h4 className="font-weight-bold mb-3" style={{ color: '#5d4037' }}>
                        Brand Not Linked
                    </h4>

                    {/* Message */}
                    <div className="mb-4 p-3 rounded" style={{
                        backgroundColor: 'white',
                        borderLeft: '4px solid #ff9800'
                    }}>
                        <p className="mb-0" style={{ color: '#666' }}>
                            This brand has not been linked to this business account.<br />
                            For more information, please contact us.
                        </p>
                    </div>

                    {/* Button */}
                    <button
                        className="btn px-4 py-2 font-weight-bold"
                        style={{
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            transition: 'all 0.3s'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f57c00'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#ff9800'}
                    >
                        <i className="fas fa-headset mr-2"></i>
                        CONTACT SUPPORT
                    </button>

                </div>
            </div>
        </>
    )
}

export default NotAssignBrand